module.exports = __webpack_public_path__ + "static/media/fancy-check-mark.223376d6.svg";